<template>
  <div v-if="!isInRole('customer')">
 <div
      class="modal fade"
      id="modal_attachment"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog slideInUp animated" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">
              Seleziona Allegati
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
          <attachments :value="value"  :linkAttachment=true :listAttachments="composeemail==null?[]:composeemail.attachments" @link="setContractAttachment" @removeattachment=removeContractEmailAttachment />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-xs btn-danger-rgba mr-2"
              data-dismiss="modal"
            >
              Annulla
            </button>
          </div>
        </div>
      </div>
    </div>

<div
      class="modal fade"
      id="modal_template"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog slideInUp animated" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">
              Seleziona Template
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
              <div class="row">
                <div class="col-12">
<label>Tipologia</label>
 <v-select placeholder="Seleziona tipologia" label="name"  index="templateCategoryId" v-model="categoryId"  :options="allcategories" @change="templateId = alltemplates.filter(x=>x.templateCategoryId== categoryId)[0].templateId"></v-select>

                </div>
                <div class="col-12">
<label>Modello</label>
 <v-select placeholder="Seleziona modello" label="name"  index="templateId" v-model="templateId"  :options="alltemplates.filter(x=>x.templateCategoryId== categoryId)"></v-select>

                </div>
              
<div class="col-12 mt-2">
<button class="btn btn-block btn-primary-rgba" @click="setAction" :disabled="categoryId == null || templateId == null || categoryId=='' || templateId==''">Seleziona </button>

</div>
</div>
           </div>
         
        </div>
      </div>
    </div>
<div
      class="modal fade"
      id="modal_company"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog slideInUp animated" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">
              Seleziona Banca
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
              <div class="row">
               <div class="col-6" v-for="item in cuser.companies" v-bind:key="item.companyId">
                        <div class="card m-b-30">
                            <div class="card-body p-0">
                                <div class="pricing text-center">
                                    <div class="pricing-top">
                                      <img class="img-fluid" :src="`assets/images/logo/${item.companyId}.svg`"/>
                                        
                                       
                                    </div>
                                   
                                    <div class="pricing-bottom pricing-bottom-basic">
                                        <div class="pricing-btn">
                                            <button type="button" class="btn btn-success font-16" @click="setCompany(item.companyId)">Scegli</button>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>

</div>
           </div>
         
        </div>
      </div>
    </div>
    <a ref="attachmentA"></a>
    <div class="email-rightbar card" v-if="email != null && linkEmail">
      <div class="card-header">
        <ul class="list-inline mb-0">
          <li class="list-inline-item">
            <span class="badge badge-danger-inverse mr-2" v-if="email.archived"
              >Archiviata</span
            >
            <span
              class="badge badge-primary-inverse mr-2"
              v-if="!email.processed"
              >Da processare</span
            >
            <h5 class="mt-2 mb-0">{{ email.subject }}</h5>
          </li>
          <li class="list-inline-item float-right">
            <button
              class="btn btn-link"
              @click="previewEmail(email.id)"
              title="Chiudi"
            >
              <i class="feather icon-x font-20"></i>
            </button>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card m-b-30">
            <div class="card-header">
              <h5 class="card-title mb-0">Filtri</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <input
                    type="text"
                    v-model="cquery"
                    class="form-control"
                    placeholder="Codice/ragione sociale/telefono/email"
                  />
                </div>
                <div class="col-4">
                  <select class="form-control" v-model="cstate">
                    <option value="">In corso</option>
                    <option value="Invoced">Fatturate</option>
                  </select>
                </div>

                <div class="col-12 text-right">
                  <button
                    class="btn btn-primary-rgba mr-2"
                    v-on:click="loadContracts"
                  >
                    <i class="feather icon-filter mr-2"></i>Filtra
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card m-b-30">
            <div class="card-body">
              <table
                ref="table"
                id="list-emailcontract-table"
                class="table table-hover w-100"
              ></table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="email-rightbar card" v-if="email == null && linkEmail">
      <div class="card-header">
        <ul class="list-inline mb-0">
          <li class="list-inline-item">
            <h5 class="mt-2 mb-0">{{ selected.length }} Email Selezionate</h5>
          </li>
          <li class="list-inline-item float-right">
            <button
              class="btn btn-link"
              @click="linkEmail = false"
              title="Chiudi"
            >
              <i class="feather icon-x font-20"></i>
            </button>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card m-b-30">
            <div class="card-header">
              <h5 class="card-title mb-0">Filtri</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <input
                    type="text"
                    v-model="cquery"
                    class="form-control"
                    placeholder="Codice/ragione sociale/telefono/email"
                  />
                </div>
                <div class="col-4">
                  <select class="form-control" v-model="cstate">
                    <option value="">In corso</option>
                    <option value="Invoced">Fatturate</option>
                  </select>
                </div>

                <div class="col-12 text-right">
                  <button
                    class="btn btn-primary-rgba mr-2"
                    v-on:click="loadContracts"
                  >
                    <i class="feather icon-filter mr-2"></i>Filtra
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card m-b-30">
            <div class="card-body">
              <table
                ref="table"
                id="list-emailcontract-table"
                class="table table-hover w-100"
              ></table>
            </div>
          </div>
        </div>
      </div>
    </div>
<div class="loadingmodal" v-if="previewLoading"><div class="loadingmodal-content text-center">
  <h5 class="mt-2 mb-0 text-center">Caricamento in corso</h5>
  <img style="width:40%" src="assets/images/preview.gif"/></div></div>
<div class="loadingmodal" v-if="sending"><div class="loadingmodal-content text-center">
  <h5 class="mt-2 mb-0 text-center">Invio email in corso</h5>
  <img style="width:40%" src="assets/images/sending.gif"/></div></div>
    <div class="card email-open-box m-b-30" v-if="email != null  && linkEmail == false && composeemail==null">
      <div class="card-header">
        <div class="row border-bottom mb-2 ">
          <div class="col-5 text-left">
            <ul class="list-inline mb-0">
              <li class="list-inline-item">
                {{ email.date | formatFullDate }}
               
              </li>
              <li
                class="list-inline-item"
                v-if="!isInRole('user') && !isInRole('readonly')"
              >
                <button
                  type="button"
                  class="btn btn-primary-rgba my-1"
                  @click="processEmail(!email.processed)"
                  :title="
                    'Segna come ' +
                    (email.processed ? 'non' : '') +
                    'processata'
                  "
                >
                  <i class="feather icon-check"></i>
                </button>
              </li>
              <li
                class="list-inline-item"
                v-if="!isInRole('user') && !isInRole('readonly')"
              >
                <button
                  type="button"
                  class="btn btn-danger-rgba my-1"
                  @click="archiveEmail"
                  v-if="!email.archived"
                  title="Segna come archiviata"
                >
                  <i class="feather icon-archive"></i>
                </button>
              </li>
              <li class="list-inline-item">
                <button
                  title="Associa a contratto"
                  type="button"
                  class="btn btn-warning-rgba my-1"
                  @click="searchContracts"
                  v-if="value == null"
                >
                  <i class="feather icon-link mr-2"></i>
                </button>
              </li>
              <li class="list-inline-item">
                <button
                  title="Scarica in formato .eml"
                  type="button"
                  class="btn btn-success-rgba my-1"
                  @click="downloadEmail(email)"
                ><i class="feather icon-download"></i>
                </button>
              </li>
            </ul>
          </div>
          <div class="col-6 text-right">
            <div class="btn-group" role="group" v-if="(!isInRole('user') && !isInRole('readonly'))">
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="choseTemplate('reply')"
              >
                <i class="text-primary fa fa-light fa-reply mr-2"></i>Rispondi
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="choseTemplate('replyall')"
              >
                <i class="text-primary fa fa-light fa-reply-all mr-2"></i
                >Rispondi a tutti
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="choseTemplate('forward')"
              >
                <i class="text-primary fa fa-light fa-arrow-right"></i> Inoltra
              </button>
            </div>
          </div>
          <div class="col-1">
            <button
              class="btn btn-link"
              @click="destroyEmail"
              title="Chiudi anteprima"
            >
              <i class="feather icon-x font-20"></i>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ul class="list-inline mb-0">
              <li class="list-inline-item">
                <span
                  class="badge badge-danger-inverse mr-2"
                  v-if="email.archived"
                  >Archiviata</span
                >
                <span
                  class="badge badge-primary-inverse mr-2"
                  v-if="!email.processed"
                  >Da processare</span
                >

                <h5 class="mt-2 mb-0">{{ email.subject }}</h5>
              </li>
              <li class="list-inline-item float-right"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row m-b-30">
          <div class="col-md-12">
            <div class="media">
              <div class="media-body">
                <h6>Da:</h6>
                <h6 class="mt-0">{{ email.from.name }}</h6>
                <span class="text-muted mb-0">{{ email.from.address }}</span
                ><br /><br />
                <h6>A:</h6>
                <span
                  class="mt-0 mr-2"
                  v-for="item in email.to"
                  :key="item.name"
                  >{{ item.address }}</span
                >
                <br />
              </div>
            </div>
          </div>

          <div class="col-md-7 text-right">
            <div class="open-email-head d-none">
              <ul class="list-inline mb-0">
                <li class="list-inline-item">
                  {{ email.date | formatFullDate }}
                </li>
                
                <li class="list-inline-item"  v-if="!isInRole('user') && !isInRole('readonly')">
                  <button
                    type="button"
                    class="btn btn-primary-rgba my-1"
                    @click="processEmail(!email.processed)"
                   
                  >
                    <i class="feather icon-check mr-2"></i>Segna come <span v-if="email.processed">non</span> processata
                  </button>
                </li>
                <li class="list-inline-item" v-if="!isInRole('user') && !isInRole('readonly')">
                  <button 
                    type="button"
                    class="btn btn-danger-rgba my-1"
                    @click="archiveEmail"
                    v-if="!email.archived"
                  >
                    <i class="feather icon-archive mr-2"></i>Segna come
                    archiviata
                  </button>
                  <button 
                    type="button"
                    class="btn btn-danger-rgba my-1"
                    @click="unarchiveEmail"
                    v-if="email.archived"
                  >
                    <i class="feather icon-archive mr-2"></i>Togli dall'archivio
                  </button>
                </li>
                <li class="list-inline-item">
                  <button
                    type="button"
                    class="btn btn-warning-rgba my-1"
                   @click="searchContracts"
                    v-if="value == null"
                  >
                    <i class="feather icon-link mr-2"></i>Associa a contratto
                  </button>

                   
                </li>
              
              </ul>
            </div>
          </div>
        </div>
        <div class="row" >
          <div class="col-md-12">
            <iframe
              frameborder="0"
              name="iframepreview"
              id="iframepreview"
              class="b-0 w-100"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12" v-if="email.attachments.length>1">
            <button
                          class="btn btn-link dropdown-item font-13"
                          v-on:click.stop="
                            downloadAttachments(email.id, 'Allegati.zip', 0, email.id)
                          "
                        >
                          <i class="feather icon-download-cloud"></i> Scarica tutti i {{email.attachments.length  }} allegati
                        </button>
          </div>
          <div
            class="col-md-3"
            v-for="item in email.attachments"
            :key="item.attachmentId"
          >
            <div class="card border-light m-b-30">
              <div class="card-header">
                <div class="row align-items-center">
                  <div class="col-9">
                    <span class="badge badge-pill badge-light">{{
                      item.fileExtension
                    }}</span>
                  </div>
                  <div class="col-3">
                    <div
                      class="dropdown"
                      v-if="!isInRole('user') && !isInRole('readonly')"
                    >
                      <button
                        class="btn btn-link l-h-20 p-0 font-18 float-right"
                        type="button"
                        id="CustomdropdownMenuButton8"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="feather icon-more-horizontal-"></i>
                      </button>
                      <div
                        class="dropdown-menu dropdown-menu-right"
                        aria-labelledby="CustomdropdownMenuButton8"
                      >
                        <button
                          class="btn btn-link dropdown-item font-13"
                          v-on:click.stop="
                            downloadAttachment(email.id, item.originalFileName, item.weight, item.attachmentId)
                          "
                        >
                          <i class="feather icon-download-cloud"></i> Download
                        </button>
                        <button
                          v-if="value"
                          class="btn btn-link dropdown-item font-13"
                          v-on:click.stop="
                            setAttachemnt(email.id, item.originalFileName)
                          "
                        >
                          <i class="feather icon-edit"></i> Associa
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <i
                      class="card-img-top fa-4x text-center p-1"
                      src=""
                      alt=""
                      :class="getExtensionIcon(item.fileExtension)"
                    ></i>
                  </div>
                </div>
              </div>

              <div class="card-body">
                <h6 class="cart-title attachment-filename" :title="item.title">
                  <button
                    class="btn btn-link"
                    v-on:click.stop="
                      downloadAttachment(email.id, item.originalFileName, item.weight, item.attachmentId)
                    "
                  >
                    {{ item.originalFileName }}
                  </button>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="open-email-footer">
          <div class="row text-right">
            <div class="col-md-12">
              <button
                type="button"
                class="btn btn-primary-rgba my-1"
                @click="processEmail"
                v-if="
                  !isInRole('user') && !isInRole('readonly') && !email.processed
                "
              >
                <i class="feather icon-check mr-2"></i>Segna come processata
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card email-open-box m-b-30" v-if="composeemail != null">
      <div class="card-header">
        <div class="row">
          <div class="col-11 text-right"></div>
          <div class="col-1 text-right">
            <button
              class="btn btn-link"
              @click="resetComposeEmail"
              title="Chiudi"
            >
              <i class="feather icon-x font-20"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
         <div class="form-group row">
          <label for="emailTo" class="col-sm-1 col-form-label">Da:</label>
          <div class="col-sm-11">
            <v-select
              name="emailFrom"             
              v-model="composeemail.from"
              :options= composeemail.fromAddresses
            >
              <div slot="no-options"></div>
            </v-select>
          </div>
        </div>
        <div class="form-group row">
          <label for="emailTo" class="col-sm-1 col-form-label">A:</label>
          <div class="col-sm-11">
             <vue-tags-input
              placeholder="A"
              :add-on-key="tagOptions"
      v-model="composeemailtotag"
      :tags="composeemailtotags"
      :autocomplete-items="composeemailtoautocompleteItems"
      @tags-changed="newTags => { composeemailtotags = newTags; composeemail.to = newTags.map((n) =>n.text);  }"
    />
           
          </div>
        </div>
        <div class="form-group row">
          <label for="emailCc" class="col-sm-1 col-form-label">CC</label>
          <div class="col-sm-11">
             <vue-tags-input
              placeholder="Cc"
             :add-on-key="tagOptions"
      v-model="composeemailcctag"
      :tags="composeemailcctags"
      :autocomplete-items="composeemailccautocompleteItems"
      @tags-changed="newTags => { composeemailcctags = newTags; composeemail.cc = newTags.map((n) =>n.text);  }"
    />
            
              <div slot="no-options"></div>
            </v-select>
          </div>
        </div>
        <div class="form-group row">
          <label for="emailBcc" class="col-sm-1 col-form-label">Ccn</label>
          <div class="col-sm-11">
            <vue-tags-input placeholder="Ccn"
             :add-on-key="tagOptions"
      v-model="composeemailccntag"
      :tags="composeemailccntags"
      :autocomplete-items="composeemailccnautocompleteItems"
      @tags-changed="newTags => { composeemailccntags = newTags; composeemail.bcc = newTags.map((n) =>n.text);  }"
    />
           
             

          </div>
        </div>
        <div class="form-group row">
          <label for="emailSubject" class="col-sm-1 col-form-label"
            >Oggetto</label
          >
          <div class="col-sm-11">
            <input
              type="text"
              v-model="composeemail.subject"
              class="form-control"
              id="emailSubject"
              placeholder="Oggetto"
            />
          </div>
        </div>
          <div class="form-group row">
          <div  class=" col-sm-1 col-form-label"
            >
            <div class="dropdown">
  <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    <i class="fa fa-paperclip"></i> Allegati
  </button>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
    <a class="dropdown-item cursor-pointer" @click="addAttachment" >Dal tuo dispositivo</a>
    <a class="dropdown-item cursor-pointer" @click="addContractAttachment">Da pratica</a>
   
  </div>
</div>
            
            
            <button v-if="false" @click="addAttachment" class="btn btn-sm btn-outline-secondary"><i class="fa fa-paperclip"></i> Allegati</button> </div
          >
           <div class="col-sm-11 ">
            <div class="row">
          
          <div
            class="col-md-3"
            v-for="(item,index) in composeemail.attachments"
            :key="item.fileName"
          >
                <div class="row">
                  <div class="col-9">
                                       <i
                      class=" fa text-center p-1"
                      src=""
                      alt=""
                      :class="getExtensionIcon(item.extension)"
                    ></i> {{ item.fileName }}
                  </div>
                  <div class="col-3">
                   
                      <button
                        class="btn btn-link l-h-20 p-0 font-18 float-right"
                        type="button"
                        id="CustomdropdownMenuButton8"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="feather icon-more-horizontal-"></i>
                      </button>
                      <div
                        class="dropdown-menu dropdown-menu-right"
                        aria-labelledby="CustomdropdownMenuButton8"
                      >
                        <button
                          class="btn btn-link dropdown-item font-13"
                          v-on:click.stop="
                            downloadEmailAttachment(item)
                          "
                        >
                          <i class="feather icon-download-cloud"></i> Download
                        </button>
                        <button
                          class="btn btn-link dropdown-item font-13"
                          v-on:click.stop="
                            removeEmailAttachment(index)
                          "
                        >
                          <i class="feather icon-trash"></i> Elimina
                        </button>
                      </div>
                    
                  </div>
                
            </div>
          </div>
          </div>
            <div id="preview">
          </div>
           </div>
        </div>
        <div class="form-group row">
          <label for="emailSubject" class="col-sm-1 col-form-label"
            >Messaggio</label
          >
          <div class="col-sm-11">
            <editor
            :api-key="tinyKey"
    tinymceScriptSrc="/tinymce_7.1.0/tinymce/js/tinymce/tinymce.min.js"

              :init="{
                height: 500,
                menubar: false,
                plugins: [
                'advlist','autolink','lists','link','image','charmap','print','preview','anchor',
      'searchreplace','visualblocks','code','fullscreen',
'insertdatetime','media','table','paste','code','help','wordcount'
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code',
              }"
              v-model="composeemail.body"
            ></editor>
          </div>
        </div>
       
        <div class="col-12 d-none">
        
          <vue-dropzone
            ref="myVueDropzone"
            id="emailattachment-dropzone"
            name="emailattachment-dropzone"
            
            :options="dropzoneOptions()"
            :useCustomSlot="true"
          >
            <div class="dropzone-custom-content">
              <h3 class="dropzone-custom-title">
                Trascina i file qui per gli allegati
              </h3>
              <div class="subtitle">
                ...o fai click per caricarlo dal tuo pc
              </div>
            </div>
          </vue-dropzone>
        </div>
        <div class="form-group row text-right">
          <div class="col-sm-12">
            <button class="btn btn-success-rgba my-1 mr-2" @click="sendEmail" :disabled="sending">
              <i class="feather icon-send mr-2"></i>Invia
            </button>

            <button @click="resetComposeEmail" class="btn btn-danger-rgba my-1">
              <i class="feather icon-trash mr-2"></i>Annulla
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="email-rightbar row" v-show="email == null && !linkEmail && composeemail == null">
     
<div class="col-3" v-if="showSubMenu">
  <div class="card m-b-30"><div class="card-body">
    <div role="tablist" aria-orientation="vertical" class="nav flex-column nav-pills">
      <a v-on:click="setCompanyType('','inbox')" data-toggle="pill" href="#v-pills-general" role="tab" aria-controls="v-pills-general" aria-selected="true" class="nav-link mb-1 active"><i class="fa fa-folder-open-o mr-2"></i>Ricevute
      </a>
      <a v-on:click="setCompanyType(c.companyId,'inbox')" v-for="c in cuser.companies"  data-toggle="pill"  href="#v-pills-general" role="tab" aria-controls="v-pills-general" aria-selected="true" class="nav-link mb-1 ml-3"><i class="fa fa-folder-o mr-2"></i>{{c.companyId}}
      </a>
      <a v-on:click="setCompanyType('','sent')" id="v-pills-general-tab" data-toggle="pill" href="#v-pills-general" role="tab" aria-controls="v-pills-general" aria-selected="true" class="nav-link mb-1"><i class="fa fa-folder-o mr-2"></i>Inviate
      </a>
      <a v-on:click="setCompanyType(c.companyId,'sent')" v-for="c in cuser.companies" data-toggle="pill"   href="#v-pills-general" role="tab" aria-controls="v-pills-general" aria-selected="true" class="nav-link mb-1 ml-3"><i class="fa fa-folder-o mr-2"></i>{{c.companyId}}
      </a>
     </div></div></div>  
</div>
<div :class="{'col-9':showSubMenu,'col-12':!showSubMenu}">
  <div class="card m-b-30">
        <div class="card-header row">
    
          <div class="col-6">
            <h4 class="page-title">Elenco Email</h4>
          </div>
          <div class="col-5 text-right">
            <button v-if="(!isInRole('user') && !isInRole('readonly'))" @click="choseTemplate('compose')" class="btn btn-block btn-primary-rgba mr-2">
              <i class="feather icon-mail mr-2"></i> Componi email
            </button>
           
          </div>
          <div class="col-1 text-right">
             <button
              title="Aggiorna"
              type="button"
              class="btn btn-round btn-primary-rgba"
              @click="loaddata"
            >
              <i class="feather icon-refresh-cw"></i>
            </button>
          </div>
        </div>
        <div class="card-body">
          <div class="row mb-5">
            <div class="col-6">
              <input
                type="text"
                class="form-control"
                placeholder="Oggetto/mittente"
                v-model="emailFilter"
                v-on:change="loaddata"
              />
            </div>
            <div class="col-3">
              <select
                class="form-control"
                v-model="processed"
                v-on:change="loaddata"
              >
                <option value="">Tutte le mail</option>
                <option value="0">Da Processare</option>
                <option value="1">Processate</option>
              </select>
            </div>
            <div
              class="col-3"
              v-if="!isInRole('user') && !isInRole('readonly')"
            >
              <select
                class="form-control"
                v-model="archived"
                v-on:change="loaddata"
              >
                <option value="">Tutte le mail</option>
                <option value="0">Escludi Achiviate</option>
                <option value="1">Archiviate</option>
              </select>
            </div>
          </div>
   <div class="card m-b-30" v-if="selected.length > 0">
        <div class="card-body border border-light">
          <div class="row">
             <div class="col-12">
                <strong>{{ selected.length }}</strong> Email Selezionate
              </div>
</div>
  <div class="row">
            <div class="col-12 mb-3">
<button v-on:click="selectAll"  class="btn btn-small btn-success-rgba mr-3">Seleziona tutti tutte le email nella pagina</button>
<button v-on:click="selectReset" class="btn btn-small btn-danger-rgba mr-3">Rimuovi selezione</button>
        </div>
           
              <div class="col-12">
                <button
                    type="button"
                    class="btn btn-small btn-success-rgba mr-3"
                    @click="searchContracts"
                     v-if="value == null"
                  >
                    <i class="feather icon-link mr-2"></i>Associa a contratto
                  </button>
 <button v-if="showSubMenu && value == null" v-for="c in cuser.companies"
                    type="button"
                    class="btn btn-small btn-success-rgba mr-3"
                    @click="setCompanyMails(c.companyId)"
                    
                  >
 <i class="feather icon-link mr-2"></i>Associa a {{c.companyId}}
                  </button>
                  <button v-if="showSubMenu && value == null && companyId!='*' && companyId!=''" 
                    type="button"
                    class="btn btn-small btn-warning-rgba mr-3"
                    @click="setCompanyMails('none')"
                    
                  >
                    <i class="feather icon-un-link mr-2"></i>Disassocia da {{companyId}}
                  </button>

          <button
                    type="button"
                    class="btn btn-success-rgba mr-2"
                   @click="processEmails"
                   
                  >
                    <i class="feather icon-check mr-2"></i>Segna come processata
                  </button>

                   <button
                    type="button"
                    class="btn btn-danger-rgba ml-1"
                   @click="archiveEmails"
                   
                  >
                    <i class="feather icon-archive mr-2"></i> Segna come archiviata
                  </button>
        </div>
            </div>
        </div></div>
          <div class="table-responsive">
            <table
              ref="table"
              id="list-inboxemail-table"
              class="table table-hover table-borderless w-100"
            ></table>
          </div>
        
      </div>
  </div>
  </div>

  </div>
</div>


    

 
   
  
</template>

<script>
import * as srcDoc from "srcdoc-polyfill";
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";
import VueTagsInput from "@johmun/vue-tags-input";
export default {
  name: "inboxemail",

  props: {
    selectable: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: false,
    },
    showSubMenu: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      companyId: "*",
      emailType:"",
      tagOptions: [13, ":", ";", ","],
      sending: false,
      previewLoading: false,
      cstate: "",
      cquery: "",
      selected: [],
      entities: [],
      email: null,
      emailFilter: "",
      processed: "",
      archived: "0",
      linkEmail: false,

      composeemail: null,
      composeemailtotags: [],
      composeemailtotag: "",
      composeemailcctags: [],
      composeemailcctag: "",
      composeemailccntags: [],
      composeemailccntag: "",
      composeemailccautocompleteItems: [],
      composeemailccnautocompleteItems: [],
      composeemailtoautocompleteItems: [],
      templateId: null,
      categoryId: null,
      allcategories: [],
      alltemplates: [],
      templates: [],
    };
  },
  computed: {
    cuser() {
      return this.$store.state.user;
    },
    tinyKey: function () {
      return window.SETTINGS.TinyApiKey;
    },
  },
  components: {
    Editor,
    VueTagsInput,
  },
  mounted() {
    if(this.showSubMenu){
      this.emailType="inbox";
      this.companyId ="";
    }
    setTimeout(this.loaddata, 200);
  },
  watch: {
    composeemailtotag: "initToItems",
    composeemailcctag: "initCcItems",
    composeemailccntag: "initCcnItems",
  },
  methods: {
    initToItems() {
      this.initItems("to");
    },
    initCcItems() {
      this.initItems("cc");
    },
    initCcnItems() {
      this.initItems("ccn");
    },
    initItems(scope) {
      if (this["composeemail" + scope + "tag"].length < 2) return;

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        axios
          .get(
            `inboxemail/searchemail?entityId=${this.value}&q=${
              this["composeemail" + scope + "tag"]
            }`
          )
          .then((response) => {
            this["composeemail" + scope + "autocompleteItems"] =
              response.data.map((a) => {
                return { text: a.email };
              });
          })
          .catch(() => console.warn("Oh. Something went wrong"));
      }, 600);
    },
    dropzoneOptions: function () {
      var me = this;

      function url() {
        return window.SETTINGS.apiUrl + "/attachment/upload/emailattachment";
      }
      return {
        url: url,
        thumbnailWidth: 80,
        thumbnailHeight: 80,
        previewsContainer: "#preview",
        headers: { Authorization: "Bearer " + this.$store.state.user.token },
        success: function (a, b) {
          this.removeFile(a);
          if (b.path != "") {
            me.composeemail.attachments.push(b);
          }
        },
      };
    },
    setContractAttachment: function (id) {
      axios
        .post("attachment/upload/setemailattachment?id=" + id)
        .then((response) => {
          this.composeemail.attachments.push(response.data);
        });
    },
    verifyemail: function (a) {
      return a;
    },
    addContractAttachment() {
      $("#modal_attachment").modal();
    },
    addAttachment() {
      $("#emailattachment-dropzone").trigger("click");
    },
    downloadEmailAttachment(item) {
      var me = this;
      var url = "";

      axios
        .post(`attachment/download/emailattachment`, item, {
          responseType: "blob",
        })
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, item.fileName);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = item.fileName;
            me.$refs.attachmentA.click();
          }
        });
    },
    removeEmailAttachment(index) {
      var toremove = this.composeemail.attachments[index];
      axios
        .post("attachment/remove/emailattachment", toremove)
        .then((response) => {
          this.composeemail.attachments.splice(index, 1);
        });
    },
    removeContractEmailAttachment(filename) {
      var toremove = this.composeemail.attachments.filter(
        (x) => x.fileName == filename
      );
      axios
        .post("attachment/remove/emailattachment", toremove[0])
        .then((response) => {
          this.composeemail.attachments = this.composeemail.attachments.filter(
            (x) => x.fileName != filename
          );
        });
    },
    setComposeEmail(data, parentid) {
      this.composeemail = data;
      this.composeemail.parentId = parentid;
      this.composeemailcctag =
        this.composeemailtotag =
        this.composeemailccntag =
          "";
      this.composeemailcctags = data.cc.map((n) => {
        return { text: n };
      });
      this.composeemailccntags = data.bcc.map((n) => {
        return { text: n };
      });
      this.composeemailtotags = data.to.map((n) => {
        return { text: n };
      });

      $("#contract-menu").addClass("d-none");
      $("#contract-tabs").addClass("total-100");
    },
    setCompany(companyId) {
      axios.get("template/company/" + companyId).then((response) => {
        this.allcategories = response.data.categories;
        this.alltemplates = response.data.templates;
        this.companyId = companyId;
        $("#modal_company").modal("hide");
     switch (this.type) {
         case "forward":
          this.forward();
          break;
      
       default:
         this.openModalTemplate();
          break;
      }
       
      });
    },
    openModalTemplate() {
      this.templateId = null;
      this.categoryId = this.allcategories[0].templateCategoryId;

      this.templatsetComposeEmaileId = this.alltemplates.filter(
        (x) => x.templateCategoryId == this.categoryId
      ).templateId;

      $("#modal_template").modal();
    },
    choseCompany(type) {
      this.type = type;
      
      if(this.email && (this.email.companyId != null && this.email.companyId!='')){

        this.setCompany(this.email.companyId);
      }
      else if (this.cuser.companies.length == 1) {
        this.setCompany(this.cuser.companies[0].companyId);
      } else {
        $("#modal_company").modal();
      }
    },
    choseTemplate(type) {
      console.log("choosetemplate",  type, this.value);
      if (!this.value) {
        this.choseCompany(type);
        return;
      }

      this.type = type;
      if(this.type== "forward"){
      //this.setaction();
      this.openModalTemplate();
      }
      else{
      this.openModalTemplate();
      }
    },
    setAction() {
      $("#modal_template").modal("hide");
      switch (this.type) {
        case "compose":
          this.compose();
          break;
        case "forward":
          this.forward();
          break;
        case "reply":
          this.reply();
          break;
        case "replyall":
          this.replyall();
          break;
      }
    },
    resetComposeEmail() {
      this.composeemail = null;
      this.composeemailcctag =
        this.composeemailtotag =
        this.composeemailccntag =
          "";
      this.composeemailcctags =
        this.composeemailccntags =
        this.composeemailtotags =
          [];
      $("#contract-menu").removeClass("d-none");
      $("#contract-tabs").removeClass("total-100");
      if (this.email != null) this.previewEmail(this.email.id);
    },
    reply: function (all) {
      this.previewLoading = true;
      axios
        .get(
          `inboxemail/reply/${this.email.id}?templateId=${
            this.templateId
          }&all=${all ? "true" : "false"}&companyId=${this.companyId}`
        )
        .then((response) => {
          this.setComposeEmail(response.data, this.email.id);
          this.previewLoading = false;
        })
        .catch((x) => {
          this.previewLoading = false;
        });
    },
    replyall: function () {
      this.reply(true);
    },
    compose: function () {
      var url = `inboxemail/new/${this.value}?templateId=${this.templateId}`;
      this.previewLoading = true;
      if (!this.value)
        url = `inboxemail/free/${this.companyId}?templateId=${this.templateId}`;
      axios
        .get(url)
        .then((response) => {
          this.setComposeEmail(response.data, null);
          this.previewLoading = false;
        })
        .catch((x) => {
          this.previewLoading = false;
        });
    },
    forward: function () {
     // this.templateId = null;
      this.previewLoading = true;
      axios
        .get(`inboxemail/forward/${this.email.id}?companyId=${this.companyId}&templateId=${this.templateId}`)
        .then((response) => {
          this.setComposeEmail(response.data, this.email.id);
          this.previewLoading = false;
        })
        .catch((x) => {
          this.previewLoading = false;
        });
    },
    sendEmail() {
      this.sending = true;
      axios
        .post(`inboxemail/send`, this.composeemail)
        .then((response) => {
          if (response.data.error) {
            this.sending = false;
            this.$swal({
              title: "Email non inviata",
              html: response.data.errormessages.join("<br/>"),
              type: "error",
              showCancelButton: false,
              toast: false,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
          } else {
            this.resetComposeEmail();
            this.$swal({
              title: "Email inviata con successo",
              text: "",
              type: "success",
              showCancelButton: false,
              toast: true,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
          }
          this.sending = false;
          this.loaddata();
        })
        .catch((e) => (this.sending = false));
    },
    processEmail: function (set) {
      var me = this;
      this.$swal({
        title: ``,
        html: `Sicuri di voler voler segnare come ${
          set ? "" : "<strong>NON</strong>"
        } processata questa mail?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .post(`inboxemail/${set ? "" : "un"}processing`, [me.email.id])
            .then((response) => {
              me.destroyEmail();
              me.$emit("update");
            });
        }
      });
    },
    processEmails: function () {
      var me = this;
      this.$swal({
        title: ``,
        html: `Sicuri di voler voler segnare come processate queste mails?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios.post(`inboxemail/processing`, me.selected).then((response) => {
            me.selected = [];
            me.loaddata();
          });
        }
      });
    },
   
    setCompanyMails: function (c) {
      var me = this;
      var message =`Sicuri di voler assegnare a ${c} queste mails?`;
      if(c=='')
      message =`Sicuri di voler disassociare da ${this.companyId} queste mails?`
      this.$swal({
        title: ``,
        html: message,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios.post(`inboxemail/company/${c}`, me.selected).then((response) => {
            me.selected = [];
            me.loaddata();
          });
        }
      });
    },
    archiveEmails: function () {
      var me = this;
      this.$swal({
        title: ``,
        html: `Sicuri di voler archiviare queste mails?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios.post("inboxemail/archiving", me.selected).then((response) => {
            me.selected = [];
            me.loaddata();
          });
        }
      });
    },
    isInRole(role) {
      for (var i = 0; i < this.cuser.roles.length; i++) {
        if (this.cuser.roles[i] == role) {
          return true;
        }
      }
      return false;
    },

    archiveEmail: function () {
      var me = this;
      this.$swal({
        title: ``,
        html: `Sicuri di voler archiviare questa mail?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios.post("inboxemail/archiving", [me.email.id]).then((response) => {
            me.destroyEmail();
          });
        }
      });
    },
    unarchiveEmail: function () {
      var me = this;
      this.$swal({
        title: ``,
        html: `Sicuri di volere togliere dall'archivio questa mail?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .post("inboxemail/unarchiving", [me.email.id])
            .then((response) => {
              me.destroyEmail();
            });
        }
      });
    },
    getExtensionIcon: function (ext) {
      if (ext) ext = ext.toLowerCase();
      else ext = "";
      switch (ext) {
        case ".txt":
          return "fa fa-file-text-o";
        case ".doc":
        case ".docx":
          return "fa fa-file-word-o  text-info";
        case ".xls":
        case ".xlsx":
        case ".csv":
          return "fa fa-file-excel-o text-success";
        case ".jpg":
        case ".jpeg":
        case ".png":
        case ".bmp":
        case ".tiff":
          return "fa fa-image text-info";
        case ".pdf":
          return "fa fa-file-pdf-o text-danger";
        case ".wav":
        case ".mp3":
          return "fa fa-file-audio-o text-warning";
        case ".ppt":
        case ".pptx":
          return "fa fa-file-powerpoint-o text-warning";
        case ".zip":
        case ".rar":
        case ".7z":
          return "fa fa-file-archive-o  text-warning";
        default:
          return "fa fa-file-o";
      }
    },
    setCompanyType(company,type){
      
this.emailType = type;
this.companyId = company;
this.archived ="";
this.processed ="";
this.emailFilter="";
this.loaddata();
    },
    setAttachemnt: function (id, o) {
      var me = this;
      axios.get(`contract/attachmentTypes/${this.value}`).then((response) => {
        me.$swal({
          title: `Associare il file ad una tipologia`,
          text: "",
          type: "question",
          input: "select",
          inputOptions: response.data,
          showCancelButton: false,
          confirmButtonClass: "btn-danger-rgba",
          confirmButtonText: "Associa",

          inputValidator: (value) => {
            return new Promise((resolve) => {
              axios
                .post("inboxemail/saveattachment", {
                  id: id,
                  type: value,
                  filename: o,
                })
                .then((result) => {
                  resolve();
                  // me.$emit("update");
                })
                .catch(() => {
                  resolve("Ops, qualcosa è andato storto");
                });
            });
          },
        });
      });
    },
    downloadAttachment: function (id, o, weight,attid) {
      var me = this;
      var url = "";

      axios
        .post(
          `inboxemail/downloadattachment`,
          { id: id, fileName: o, weight: weight, attachmentId:attid },
          { responseType: "blob" }
        )
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },
    downloadEmail: function (e) {
      var me = this;
      var o =e.subject+'.eml';

      axios
        .post(
          `inboxemail/${e.id}/download`,
          { responseType: "blob" }
        )
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },
    downloadAttachments: function (id, o, weight,attid) {
      var me = this;
      var url = "";

      axios
        .post(
          `inboxemail/downloadattachments`,
          { id: id, fileName: o, weight: weight, attachmentId:attid },
          { responseType: "blob" }
        )
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },
    destroyEmail() {
      $("#iframepreview").attr("srcdoc", "Caricamento anteprima in corso");
      var me = this;
      me.email = null;
      setTimeout(function () {
        if ($.fn.DataTable.isDataTable("#list-inboxemail-table")) {
             $("#list-inboxemail-table").DataTable().ajax.reload(null, false);
        }}, 300);
    },
    previewEmail(id) {
      this.previewLoading = true;
      var me = this;
      me.composeemail == null;
      me.linkEmail = false;
      var tempmail = null;
      if ($.fn.DataTable.isDataTable("#list-emailcontract-table")) {
        $("#list-emailcontract-table").DataTable().destroy();
      }

      axios.get(`inboxemail/${id}/information`).then((response) => {
        tempmail = response.data;
        tempmail.id = id;
        tempmail.attachments = [];
        axios.get(`inboxemail/${id}/attachments`).then((response) => {
          tempmail.attachments = response.data;
          me.email = tempmail;
          me.previewLoading = false;
          setTimeout(function () {
            $("#iframepreview").attr(
              "srcdoc",
              "Caricamento anteprima in corso"
            );
            axios.get(`inboxemail/${id}/html`).then((response) => {
              $("#iframepreview").attr("srcdoc", response.data);
              setTimeout(function () {
                $("#iframepreview")[0].style.height =
                  $("#iframepreview")[0].contentWindow.document.documentElement
                    .scrollHeight + "px";
              }, 500);
            });
          }, 200);
        });
      });
    },

    loaddata: function () {
      if (this.value) {
        axios.get("template/contract/" + this.value).then((response) => {
          this.allcategories = response.data.categories;
          this.alltemplates = response.data.templates;
        });
      } else{

        axios.get("template/templates").then((response) => {
          this.allcategories = response.data.categories;
          this.alltemplates = response.data.templates;
        });
      }
      window.setEmails = this.setEmails;
      if ($("#list-inboxemail-table").length == 0) {
        setTimeout(this.loaddata, 100);
        return;
      }
      window["EditAction"] = this.edit;
      var me = this;

     
      if ($.fn.DataTable.isDataTable("#list-inboxemail-table")) {
        $("#list-inboxemail-table").DataTable().destroy();
      }
      me.email = null;
      var columns = [
        {
          data: "inBoxEmailId",
          name: "",
          title: "",
          render: function (data, type, row, meta) {
            var checked = "";
            if (me.selected.filter((c) => c == data).length > 0) {
              checked = "checked";
            }

            return `
               <div class="custom-control custom-switch">
  <input type="checkbox" ${checked} class="emailCheck custom-control-input" id="chk-${data}" value="${data}" onClick="window.setEmails('${row.inBoxEmailId}')">
  <label class="custom-control-label" for="chk-${data}"></label>
</div>
            `;
          },
        },
        {
          data: "inBoxEmailId",
          name: "",
          title: "",
          class: "email-info",
          render: function (data, type, row, meta) {
            var retval =""
            if (row.hasAttachments) {
              retval  =  `<i class="feather icon-paperclip mr-2"></i>`;
            }  
            if(row.type =="Sent"){
              retval  +=  `<i class="feather icon-send" title="Email inviata"></i>`;


            }
              return retval;
            
          },
        },
        {
          data: "inBoxEmailId",
          name: "",
          title: "",
          class: "email-info",
          render: function (data, type, row, meta) {
            if (row.fromName != "") {
              return `${row.fromName}<br/><small class="text-muted">(${row.fromEmail})</small>`;
            } else {
              return row.fromEmail;
            }
          },
        },

        {
          data: "subject",
          name: "",
          title: "",
          class: "email-info",
          render: function (data, type, row, meta) {
            return (
              (row.processed
                ? ""
                : '<span class="badge badge-primary-inverse mr-2">Da Processare</span> ') +
              (!row.archived
                ? ""
                : '<span class="badge badge-danger-inverse mr-2">Archiviata</span> ') +
                row.subject
            );
          },
        },
        {
          data: "subject",
          name: "date",
          title: "",
          class: "email-info",
          render: function (data, type, row, meta) {
            return me.$options.filters.formatFullDate(row.date);
          },
        },
      ];
      if (!this.selectable) columns.splice(0, 1);
      var $table = $("#list-inboxemail-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url:
            window.SETTINGS.apiUrl +
            "/inboxemail/list/" +
            (me.value ? me.value : ""),
          type: "POST",
          data: function (d) {
            d.search.value = me.emailFilter;
            d.filters = [
               {
                key: "companyid",
                value: me.companyId,
              },
              {
                   key: "type",
                value: me.emailType,
              },
              {
                key: "processed",
                value: me.processed,
              },
              {
                key: "archived",
                value: me.archived,
              },
            ];
            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },
        createdRow: function (row, data, dataIndex) {
          $(row).data("id", data.inBoxEmailId);
          if (!data.processed) {
            $(row).addClass("email-unread");
          }
          if (data.archived) {
            $(row).addClass("text-danger");
          }
        },
        columns: columns,
      });
      $("#list-inboxemail-table").on("click", "td.email-info", function () {
        var tr = $(this).parent("tr");
        //var data = $table.row(setEmailstr[0]).data();

        me.previewEmail($(tr).data("id"));
      });
    },
    setEmails: function (id) {
      var isChecked = global.$("#chk-" + id).is(":checked");
      if (isChecked) {
        if (this.selected.filter((c) => c == id).length == 0) {
          this.selected.push(id);
        }
      } else {
        this.selected = this.selected.filter((c) => c != id);
      }
      // event.tags.toLowerCase().values().includes(this.filterValue.toLowerCase())

      return false;
    },
    selectAll: function () {
      var me = this;
      global.$(".emailCheck").each(function () {
        this.checked = true;
        me.setEmails(this.value);
      });
    },
    selectReset: function () {
      this.selected = [];
      $("#list-inboxemail-table").DataTable().ajax.reload(null, false);
    },
    searchContracts: function () {
      this.linkEmail = true;
      setTimeout(this.loadContracts, 200);
    },
    setContractSelected: function (id) {
      var me = this;
      this.$swal({
        title: ``,
        html: `Sicuri di voler associare <strong>${this.selected.length} emails</strong> al contratto selezionato?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .post(`inboxemail/multilink/`, { id: id, ids: me.selected })
            .then((response) => {
              me.$swal({
                title: "Associazione avvenuta correttamente",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });

              me.selected = [];
              setTimeout(function () {
                $("#list-inboxemail-table")
                  .DataTable()
                  .ajax.reload(null, false);
              }, 200);
            });
        }
      });
    },
    setContract: function (id) {
      if (this.email == null && this.selected.length > 0)
        return this.setContractSelected(id);
      var me = this;
      this.$swal({
        title: ``,
        html: `Sicuri di voler associare questa mail?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .post(`inboxemail/link/${me.email.id}/${id}`)
            .then((response) => {
              me.$swal({
                title: "Associazione avvenuta correttamente",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });

              me.email = null;
              setTimeout(me.loaddata, 200);
            });
        }
      });
    },
    loadContracts: function () {
      var me = this;
      window.setContract = me.setContract;
      if ($.fn.DataTable.isDataTable("#list-emailcontract-table")) {
        $("#list-emailcontract-table").DataTable().destroy();
      }

      var $ctable = $("#list-emailcontract-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/contract/list",
          type: "POST",
          data: function (d) {
            d.search.value = me.cquery;

            d.filters = [{}];

            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "contractId",
            name: "contractId",
            title: "Ragione sociale",
            render: function (data, type, row, meta) {
              var retval = `
              <span class="badge badge-primary">${me.$options.filters.contractState(
                row.state
              )}</span> <span class="badge badge-success capitalize">${
                row.procedureId
              }</span> <span class="badge badge-info capitalize">${
                row.ransomId
              } ${row.subRansomId}</span>
              <h4>${row.code} </h4>
              <h5>${row.companyName}</h5>
              `;
              return retval;
            },
          },
          {
            className: "text-right",
            data: "contractId",
            name: "contractId",
            title: "Azioni",
            render: function (data, type, row, meta) {
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.setContract('${row.contractId}')"><i class="feather icon-link"></i></button>
                                   `;
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="css">
#modal_attachment {
  min-width: 100%;
  margin: 0;
}

#modal_attachment .modal-content {
  min-height: 100vh;
}

#modal_attachment .modal-dialog {
  min-width: 100%;
  margin: 0;
}

[class^="ti-"],
[class*=" ti-"] {
  font-family: "Muli", sans-serif !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ti-tag {
  font-family: "Muli", sans-serif !important;
  display: flex !important;
  align-items: center !important;
  background-color: #f0f0f0 !important;
  border: 1px solid #ccc !important;
  border-radius: 4px !important;
  color: #333 !important;
  line-height: 1.42857143 !important;
  margin: 4px 2px 0 !important;
  padding: 0 0.25em !important;
  transition: opacity 0.25s !important;
}
.ti-tag:before {
  content: "" !important;
}
.vue-tags-input {
  max-width: 100% !important;
  position: relative;
  background-color: #fff;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.1s;
  transition: 0.1s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.nav-link {
  cursor: pointer;
}

#list-inboxemail-table thead {
  display: none;
}

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.75);
}
.loadingmodal {
  z-index: 999;
  position: fixed; /* Stay in place */

  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(255, 255, 255); /* Fallback color */
  background-color: rgba(255, 255, 255, 0.7); /* Black w/ opacity */
}

/* Modal Content (image) */
.loadingmodal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  position: relative;
}
.loadingmodal-content div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
